export const tabItems = [
  {
    icon: 'ai',
    label: 'BraineeBot',
    name: 'BraineeBot',
  },
  {
    icon: 'web',
    label: 'Web Search',
    name: 'Web',
  },    
  // {
  //   icon: 'videos',
  //   label: 'videos',
  //   name: 'videos',
  // },  
  // {
  //   icon: 'images',
  //   label: 'images',
  //   name: 'images',
  // },  
  {
    icon: 'texts',
    label: 'text',
    name: 'Text',
  },   
  {
    icon: 'url',
    label: 'url',
    name: 'Links',
  },   
  {
    icon: 'embed',
    label: 'embed',
    name: 'Embed',
  },      
  {
    icon: 'myfiles',
    label: 'My Files',
    name: 'My Files',
  },    
  {
    icon: 'thirdparty',
    label: 'Digital tools',
    name: 'Digital tools',
  },   
  {
    icon: 'background',
    label: 'background',
    name: 'Background',
  },  
  {
    icon: 'vector',
    label: 'vector',
    name: 'Vector',
  },     
  {
    icon: 'objects',
    label: 'objects',
    name: 'Objects',
  },     
]
